import React, { useState } from 'react';
import {
  Form, Grid, Segment, Header,
  Divider, Button, Icon,
} from 'semantic-ui-react';

const Choice = {
  NEW: 'new',
  COPY: 'copy',
};

const SurveyCreationForm = ({
  project, loading, submit, onCancel,
}) => {
  const [file, setFile] = useState(null);
  const [choice, setChoice] = useState(null);
  return (
    <Form>
      <Grid.Row>
        <Segment>
          <Header className="project-title">
            Create Project
          </Header>
          <Divider />
          <p>
            Would you like to create your survey from scratch or copy content from a past project?
          </p>
          <Form.Radio
            label="Start from scratch — I want to create a brand new survey."
            checked={choice === Choice.NEW}
            onClick={() => setChoice(Choice.NEW)}
          />
          <Form.Radio
            label="Copy from a past project — I’d like to reuse content from one of my previous surveys."
            checked={choice === Choice.COPY}
            onClick={() => setChoice(Choice.COPY)}
          />
        </Segment>
        {choice === Choice.COPY && (
          <Segment>
            <Header className="project-title">
              Export and Upload your previous survey
            </Header>
            <Divider />
            <p>
              {'Please follow the instruction '}
              <a href="https://www.qualtrics.com/support/survey-platform/survey-module/survey-tools/import-and-export-surveys/#ExportingaSurveyasaQSF" target="_blank" rel="noreferrer">
                here
              </a>
              {' to export your previous survey as a Qualtrics Survey Format (QSF) file from Qualtrics.'}
            </p>
            <p>
              Once you have the exported QSF file,
              upload the file below then click “Create Project” to proceed.
            </p>
            <Segment>
              <Form.Group inline>
                <input
                  type="file"
                  id="getFile"
                  style={{ display: 'none' }}
                  onChange={(e) => {
                    e.preventDefault();
                    const uploadedFile = e.target.files[0];
                    const { validity } = e.target;
                    if (validity.valid) {
                      setFile(uploadedFile);
                    }
                  }}
                />
                <Form.Button
                  onClick={() => {
                    document.getElementById('getFile').click();
                  }}
                >
                  <Icon name="upload" />
                  Upload the QSF file
                </Form.Button>
                {file && (
                  <Form.Field>
                    <Header color="green" as="h5">{file.name}</Header>
                  </Form.Field>
                )}
              </Form.Group>
            </Segment>
          </Segment>
        )}
      </Grid.Row>
      <Grid.Row className="actions">
        <Form.Field className="buttons">
          <Button
            as="a"
            loading={loading}
            disabled={loading}
            className="basic-btn"
            onClick={onCancel}
          >
            Back
          </Button>
          <Button
            className="primary-btn"
            loading={loading}
            disabled={!choice || (choice === Choice.COPY && !file) || loading}
            onClick={() => submit(project, file)}
          >
            Create Project
          </Button>
        </Form.Field>
      </Grid.Row>
    </Form>
  );
};

export default SurveyCreationForm;
